interface RoomChangeInfoProps {
  type: 'upgrade' | 'move';
  color: 'blue' | 'green' | 'red';
  current: boolean;
  price?: string;
  title: string;
  children: React.ReactElement;
}

const RoomChangeInfo = ({
  type,
  current,
  color,
  price,
  title,
  children,
}: RoomChangeInfoProps) => {
  const frameText =
    type === 'move'
      ? current
        ? 'Current position'
        : 'Selected position'
      : current
      ? 'Current'
      : 'Next upgrade';

  return (
    <div className={`room-change-info-container ${color}`}>
      <div className="room-change-frame-text">{frameText}</div>
      <div className="room-change-info-title">{title}</div>
      <div className="room-change-info-price">{price}</div>
      <div className="room-change-info-text">{children}</div>
    </div>
  );
};

export default RoomChangeInfo;
